import React from 'react'

interface Props {
    text: string
    className?: string
}
export const SimpleHtmlTypography = ({ className, text }: Props) =>
	<span className={className} dangerouslySetInnerHTML={{ __html: text }} />